import script from "./weighbridge-screen.vue?vue&type=script&setup=true&lang=js"
export * from "./weighbridge-screen.vue?vue&type=script&setup=true&lang=js"

import "./weighbridge-screen.vue?vue&type=style&index=0&id=267d474c&scoped=true&lang=css"

import exportComponent from "E:\\maoqiaoProjectFile\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-267d474c"]])

export default __exports__